var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5V12.7143C14.6667 13.4241 14.1068 14 13.4167 14H2.58337C1.89327 14 1.33337 13.4241 1.33337 12.7143V5C1.33337 4.29018 1.89327 3.71429 2.58337 3.71429H4.87504L5.19535 2.83304C5.37765 2.33214 5.84379 2 6.36462 2H9.63285C10.1537 2 10.6198 2.33214 10.8021 2.83304L11.125 3.71429H13.4167C14.1068 3.71429 14.6667 4.29018 14.6667 5ZM8.00004 12C9.84099 12 11.3334 10.5076 11.3334 8.66667C11.3334 6.82572 9.84099 5.33333 8.00004 5.33333C6.15909 5.33333 4.66671 6.82572 4.66671 8.66667C4.66671 10.5076 6.15909 12 8.00004 12ZM8.00004 10.8C9.17825 10.8 10.1334 9.84487 10.1334 8.66667C10.1334 7.48846 9.17825 6.53333 8.00004 6.53333C6.82183 6.53333 5.86671 7.48846 5.86671 8.66667C5.86671 9.84487 6.82183 10.8 8.00004 10.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0acce8cf0afefe4cffa5f3b3af69fc04.svg";
export { ForwardRef as ReactComponent };